<template lang="html">
    <div id="page__paymentmethods" class="center-panel">
        <md-content md-theme="white">
            <sort-table
                v-bind:columns="tableColumns" v-model="methods" @refresh="getMethods" v-bind:per-page="perPage" v-bind:showAddButton="false"
                v-bind:total="methodsAmount" link table-id="paymentmethods" ref="table"
            >
                <span slot="type" slot-scope="scope" v-if="scope.item.type">{{ (types && types[scope.item.type]) ? types[scope.item.type]['name'] : '' }}</span>
                <span slot="active" slot-scope="scope">{{ (scope.item.active && parseInt(scope.item.active) !== 0) ? 'Автивен' : 'Отключён' }}</span>
                <span slot="public" slot-scope="scope">{{ (scope.item.public && parseInt(scope.item.public) !== 0) ? 'Да' : 'Нет' }}</span>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import SortTable from '@/components/SortTable';
    export default {
        components: { SortTable },
        data() {
            return {
                perPage: 50,
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true },
                    { label: 'Наименование', field: 'name'},
                    { label: 'Тип', field: 'type'},
                    { label: 'Активность', field: 'active'},
                    { label: 'Публичный', field: 'public'},
                    { label: '', field: 'actions' },
                ],
                deleteDialog: false,
                methodToDelete: {},
                types: {
                    1: {
                        name: 'Онлайн оплата',
                        value: 1,
                    },
                    2: {
                        name: 'Оплата по счёту',
                        value: 2,
                    },
                    3: {
                        name: 'Наличными с чеком',
                        value: 3,
                    },
                    4: {
                        name: 'Наличными без чека',
                        value: 4,
                    },
                    5: {
                        name: 'По карте',
                        value: 5,
                    },
                    6: {
                        name: 'СПБ',
                        value: 6,
                    }
                }
            }
        },
        computed: {
            /**
             * Список методов
             */
            methods() {
                return this.$store.state.cost.payment_methods.map(method => {
                    method.routerLink = { name: 'PaymentMethod', params: { method_id: method.id }, query: this.$route.query };
                    return method;
                });
            },
            /**
             * Количество методов
             */
            methodsAmount() {
                return this.$store.state.cost.payment_methods_amount;
            },
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['methods-groups-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        watch: {
            '$route.name'(name) {
                if (name == 'PaymentMethods') this.init();
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.$store.commit('setTitle', 'Способы оплаты');
            },
            /**
             * Получение методов
             */
            getMethods(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'methods-groups-list');
                this.$store.dispatch('cost/getPaymentMethods', {page: page, order_by: orderBy, order_type: orderType, count: count})
                    .finally(() => this.$store.commit('hideProgressBar', 'methods-groups-list'));
            }
        },
    }
</script>


// WEBPACK FOOTER //
// PaymentMethods.vue?0bc30676